// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__m6Ddj","scrolled_navbar":"navbar_scrolled_navbar__Et9eO","active":"navbar_active__yU-0k"};